import {IconSize, iconStrokeWidthBySize} from '../icon_types';

type MoreVerticalIconProps = {
  id?: string;
  className?: string;
  size: IconSize;
  color?: string;
};

const pathDsBySize = {
  '16': [
    'M8.00016 8.66668C8.36835 8.66668 8.66683 8.3682 8.66683 8.00001C8.66683 7.63182 8.36835 7.33334 8.00016 7.33334C7.63197 7.33334 7.3335 7.63182 7.3335 8.00001C7.3335 8.3682 7.63197 8.66668 8.00016 8.66668Z',
    'M8.00016 3.99999C8.36835 3.99999 8.66683 3.70151 8.66683 3.33332C8.66683 2.96513 8.36835 2.66666 8.00016 2.66666C7.63197 2.66666 7.3335 2.96513 7.3335 3.33332C7.3335 3.70151 7.63197 3.99999 8.00016 3.99999Z',
    'M8.00016 13.3333C8.36835 13.3333 8.66683 13.0349 8.66683 12.6667C8.66683 12.2985 8.36835 12 8.00016 12C7.63197 12 7.3335 12.2985 7.3335 12.6667C7.3335 13.0349 7.63197 13.3333 8.00016 13.3333Z',
  ],
  '24': [
    'M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z',
    'M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z',
    'M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z',
  ],
  '32': [
    'M15.9998 17.3333C16.7362 17.3333 17.3332 16.7364 17.3332 16C17.3332 15.2636 16.7362 14.6667 15.9998 14.6667C15.2635 14.6667 14.6665 15.2636 14.6665 16C14.6665 16.7364 15.2635 17.3333 15.9998 17.3333Z',
    'M15.9998 7.99999C16.7362 7.99999 17.3332 7.40304 17.3332 6.66666C17.3332 5.93028 16.7362 5.33333 15.9998 5.33333C15.2635 5.33333 14.6665 5.93028 14.6665 6.66666C14.6665 7.40304 15.2635 7.99999 15.9998 7.99999Z',
    'M15.9998 26.6667C16.7362 26.6667 17.3332 26.0697 17.3332 25.3333C17.3332 24.597 16.7362 24 15.9998 24C15.2635 24 14.6665 24.597 14.6665 25.3333C14.6665 26.0697 15.2635 26.6667 15.9998 26.6667Z',
  ],
};

const MoreVerticalIcon = (props: MoreVerticalIconProps) => {
  const {id, className, size, color} = props;
  const paths = pathDsBySize[size];
  const colorOptions = color || 'currentColor' || '#1E1E20';

  return (
    <svg
      id={id}
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none">
      {paths.map((d, index) => (
        <path
          key={index}
          d={d}
          stroke={colorOptions}
          strokeWidth={iconStrokeWidthBySize[size]}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ))}
    </svg>
  );
};

export default MoreVerticalIcon;
